var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.circum)?_c('router-view'):_vm._e(),(!_vm.circum)?_c('div',{staticClass:"bgtq"},[_c('div',[_vm._v(" 请用 支付宝，钉钉 打开 ")])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }